import { render, staticRenderFns } from "./ReservationInfoFromRoom.vue?vue&type=template&id=63901877&"
import script from "./ReservationInfoFromRoom.vue?vue&type=script&lang=js&"
export * from "./ReservationInfoFromRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports